define('plugin/gallery/model/GalleryModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Gallery data model
     *
     * @class GalleryModel
     */
    return BaseModel.extend({

        urlRoot: '/ext/gallery/by/id/',

        defaults: {
            id: '',
            file_id: '',
            description: '',
            path: '/image_files',
            original: '',
            preview: ''
        }

    });

});
